export default function createProfile(element: HTMLElement) {
	Promise.all([
		import('react'),
		import('react-dom'),
		import('./user-status'),
	]).then(([React, ReactDOM, { default: UserStatus }]) => {
		ReactDOM.render(<UserStatus />, element);
	});
}
